// be carefull all placeholders must be define in German and english.
// it is not created by passolo
export const lng: object = {};
